import React from 'react';
import { observer } from 'mobx-react-lite';
import Icon from '../../../../components/icons/icon/icon';
import FontHeading3 from '../../../../components/fonts/font-heading3/font-heading3';
import FontHeading4 from '../../../../components/fonts/font-heading4/font-heading4';
import { FONT_VARIANT, FONT_COLOR } from '../../../../components/fonts/font-props';
import IconRequireAttention from '../../../../components/icons/icon-require-attention/icon-require-attention';
import IconChevronRight from '../../../../components/icons/icon-chevron-right/icon-chevron-right';
import './error-distribution-line.scss';
import HealthDashboardPageStore from "../../health-dashboard-page-store";

interface IErrorDistributionLineProps {
    errorType: string;
    count: number;
    percentage?: number;
    onClick?: () => void;
}

const ErrorDistributionLine: React.FC<IErrorDistributionLineProps> = observer(({ 
    errorType, 
    count, 
    percentage,
    onClick
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const iconColor = HealthDashboardPageStore.getIconColor(percentage);

    return (
        <div className="error-distribution-line-content" onClick={handleClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
            <Icon Component={IconRequireAttention} color={iconColor} />
            <FontHeading3 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>
                {count}
            </FontHeading3>
            <FontHeading4 color={FONT_COLOR.NEUTRAL12}>
                {errorType}
            </FontHeading4>
            {percentage !== undefined && (
                <FontHeading4 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT1}>
                    {percentage.toFixed(1)}%
                </FontHeading4>
            )}
            <Icon Component={IconChevronRight} />
        </div>
    );
});

export default ErrorDistributionLine;
